/**
 * SQL 진단 리포트 API (docs/features/22-sql-review.md) — DB 연결 없이 쿼리·실행계획 글만으로.
 *
 * 입력·기계 분석·리포트는 `/sql-review`(AI 무관), AI 단계와 사례 연계만 `/assistant/sql-review`.
 * 연결 id 를 싣지 않는다 — 이 기능은 DB 에 접속하지 않는다.
 */
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || '/sql-developer';
const ROOT = `${BASE_URL}/sql-review`;
const AI_ROOT = `${BASE_URL}/assistant/sql-review`;
const enc = encodeURIComponent;
// AI 단계는 길 수 있다(서버 상한 4분) — 끊을 때는 signal(「중지」)
const LONG = { timeout: 6 * 60 * 1000 };

export async function listJobs(q = '') { return (await axios.get(`${ROOT}/jobs`, { params: { q } })).data; }
export async function createJob({ title, input }) { return (await axios.post(`${ROOT}/jobs`, { title, input })).data; }
export async function getJob(id) { return (await axios.get(`${ROOT}/jobs/${enc(id)}`)).data; }
export async function patchJob(id, patch, { title, step } = {}) { return (await axios.put(`${ROOT}/jobs/${enc(id)}`, { patch, title, step })).data; }
export async function deleteJob(id) { return (await axios.delete(`${ROOT}/jobs/${enc(id)}`)).data; }
/** 기계 분석 — 실행계획 글에서 증상을 뽑는다(LLM 아님) */
export async function analyzeJob(id) { return (await axios.post(`${ROOT}/jobs/${enc(id)}/analyze`, {})).data; }
export async function getReport(id, view) { return (await axios.get(`${ROOT}/jobs/${enc(id)}/report`, { params: view === 'brief' ? { view: 'brief' } : undefined })).data; }

/** 올린 자료(이미지·파일) → 쿼리·계획·참고 정보. 칸만 채운다(저장은 사람이) */
export async function readSources({ sourceIds, provider }, signal) {
  return (await axios.post(`${AI_ROOT}/read`, { sourceIds, provider }, { ...LONG, signal })).data;
}
/** AI 단계 — diagnose · alternatives · final. instruction 을 주면 「다시 쓰기」 */
export async function aiStep(id, step, { provider, instruction } = {}, signal) {
  return (await axios.post(`${AI_ROOT}/jobs/${enc(id)}/ai/${enc(step)}`, { provider, instruction }, { ...LONG, signal })).data;
}
/** 튜닝 가이드 — 이 작업에 실리는 것·고를 수 있는 것(연결이 없어 매핑은 못 쓴다) · 분류 코드 목록. 둘 다 LLM 을 부르지 않는다 */
export async function getGuide(id) { return (await axios.get(`${ROOT}/jobs/${enc(id)}/guide`)).data; }
export async function getTopics() { return (await axios.get(`${BASE_URL}/assistant/tuning-cases/topics`)).data; }
export async function findCases(id) { return (await axios.post(`${AI_ROOT}/jobs/${enc(id)}/cases`, {})).data; }
export async function caseSeed(id) { return (await axios.get(`${AI_ROOT}/jobs/${enc(id)}/case-seed`)).data; }
